export function shouldDisableRatioButton(mode = 1) {
  const sequenceEntries = this.call('getRatioOptions', true)
  const entryIndex = sequenceEntries.findIndex(
    ([, value]) => value === this.state.value
  )

  return (
    (mode === -1 && entryIndex === 0) ||
    (mode === 1 && entryIndex === sequenceEntries.length - 1)
  )
}

export function handleRatioButtons(mode = 1) {
  const sequenceEntries = this.call('getRatioOptions', true)
  const entryIndex = sequenceEntries.findIndex(
    ([, value]) => value === this.state.value
  )

  if (
    (mode === -1 && entryIndex === 0) ||
    (mode === 1 && entryIndex === sequenceEntries.length - 1)
  ) {
    return
  }

  const [key, value] = sequenceEntries[entryIndex + 1 * Number(mode)]
  this.state.update({ key, value })
}

export function handleBaseSizeButtons(mode = 1) {
  const options = this.call('getBaseSizeOptions')
  const entryIndex = options.findIndex(
    ({ value }) => value === this.state.value
  )

  if (
    (mode === -1 && entryIndex === 0) ||
    (mode === 1 && entryIndex === options.length - 1)
  ) {
    return
  }

  const { key, value } = options[entryIndex + 1 * Number(mode)]
  this.state.update({ key, value })
}

export function getBaseSizeOptions() {
  return new Array(14).fill().map((c, index) => {
    const value = index + 11
    return { key: `1em ~ ${value}px`, value }
  })
}

export function getRatioOptions(entries = false) {
  const sequence = {
    'minor-second': 1.067,
    'major-second': 1.125,
    'minor-third': 1.2,
    'major-third': 1.25,
    'perfect-fourth': 1.333,
    'augmented-fourth': 1.414,
    'perfect-fifth': 1.5,
    'minor-sixth': 1.6,
    'golden-ratio': 1.618, // golden-ratio
    'major-sixth': 1.667,
    'square-root-3': 1.732, // theodorus
    'minor-seventh': 1.778,
    'major-seventh': 1.875,
    octave: 2,
    'square-root-5': 2.23, // pythagoras
    'major-tenth': 2.5,
    'major-eleventh': 2.667,
    'major-twelfth': 3,
    pi: 3.14, // archimedes
    'double-octave': 4
  }

  if (entries) {
    return Object.entries(sequence)
  }

  return sequence
}

export function renderRangeDropdownValue(valueKey, index) {
  const position = valueKey === 'key' ? 0 : 1
  const key = this.state.key?.[index]
  if (key) {
    return valueKey === 'key'
      ? key.split(' ~')[position]
      : `~${key.split(' ~')[position]}`
  }

  if (!this.state.parent?.value) {
    return null
  }

  const { base, ratio } = this.state.parent.value
  const data = this.call(
    'generateSequencePosition',
    { base, ratio },
    this.state.value[index]
  )

  if (!data) {
    return null
  }

  const [sequence] = Object.values(data.sequence)

  return valueKey === 'key' ? sequence[valueKey] : `~${sequence[valueKey]}em`
}

export function generateRangeOptions(quantity, mode = 1) {
  if (!this.state.parent?.value) {
    return []
  }

  return new Array(quantity).fill().map((c, index) => {
    const value = index + quantity * mode
    const { base, ratio } = this.state.parent.value
    const data = this.call('generateSequencePosition', { base, ratio }, value)

    if (!data) {
      return null
    }

    const [sequence] = Object.values(data.sequence)

    return {
      key: `${sequence.key} ~${sequence.scaling}em`,
      value
    }
  })
}
